export function withOptionalId(sectionID?: string, fallback?: string) {
  if (sectionID) return { id: sectionID } as const;
  if (fallback) return { id: fallback } as const;
  return {} as const;
}
